import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'list'];

  connect() {
    this.tabTargets.forEach(tab => {
      tab.addEventListener('click', () => this.switchTab(tab));
    });

    if (window.innerWidth <= 960) {
      const items = this.listTarget.querySelectorAll('.post__item');

      // 既に .rank__carousel 済みならスキップ
      if (this.listTarget.querySelector('.rank__carousel')) return;

      if (items.length > 1) {
        const carouselWrapper = document.createElement('div');
        carouselWrapper.classList.add('rank__carousel');

        // 2つ目以降を移動
        items.forEach((item, index) => {
          if (index > 0) {
            carouselWrapper.appendChild(item);
          }
        });

        this.listTarget.appendChild(carouselWrapper);
      }
    }
  }

  switchTab(activeTab) {
    // タブの見た目切り替え
    this.tabTargets.forEach(tab => {
      if (tab === activeTab) {
        tab.classList.add('is-active');
      } else {
        tab.classList.remove('is-active');
      }
    });
  }
}